import { MenuItemIcon } from '@/components/MenuItem/MenuItemIcon';
import SendToBack from '@/images/position/ToBack.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { sendElementsToBack } from '../../../../actions/arrange/SendToBack';

interface Props {
    disabled: boolean;
}

export const SendToBackMenuItem = ({ disabled }: Props) => {
    const { store } = useAdvancedEditorContext();
    const selectedElements = store.selectedElements;

    const handleClick = () => {
        sendElementsToBack(store, selectedElements);
    };

    return <MenuItemIcon disabled={disabled} onClick={handleClick} src={SendToBack} text="Send to back" />;
};
